// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bars';

export const Component = () => (
  <path d='M3.5 4.5h18v1.885h-18V4.5Zm0 7.08h18v1.84h-18v-1.84Zm0 7.035h18V20.5h-18v-1.885Z' />
);

export const viewBox = '0 0 25 25';
